import { render, staticRenderFns } from "./WalletTypeModal.vue?vue&type=template&id=de018e16"
import script from "./WalletTypeModal.vue?vue&type=script&lang=js"
export * from "./WalletTypeModal.vue?vue&type=script&lang=js"
import style0 from "./WalletTypeModal.vue?vue&type=style&index=0&id=de018e16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports